/**
 * App Widgets
 */
import React from 'react';
import lazyLoad from 'Util/lazyLoad';
import PreloadWidget from 'Components/PreloadLayout/PreloadWidget';

const MyLoadingComponent = () => (
   <PreloadWidget />
)

const DailySales = lazyLoad(() => import("./DailySales"), MyLoadingComponent);

const ToDoListWidget = lazyLoad(() => import("./ToDoList"), MyLoadingComponent);

const CampaignPerformance = lazyLoad(() => import("./CampaignPerformance"), MyLoadingComponent);

const SupportRequest = lazyLoad(() => import("./SupportRequest"), MyLoadingComponent);

const NewCustomersWidget = lazyLoad(() => import("./NewCustomers"), MyLoadingComponent);

const Notifications = lazyLoad(() => import("./Notifications"), MyLoadingComponent);

const UserProfile = lazyLoad(() => import("./UserProfile"), MyLoadingComponent);

const QuoteOFTheDay = lazyLoad(() => import("./QuoteOfTheDay"), MyLoadingComponent);

const WeatherWidgetV2 = lazyLoad(() => import("./WeatherV2"), MyLoadingComponent);

const NewEmailsWidget = lazyLoad(() => import("./NewEmails"), MyLoadingComponent);

const EmployeePayrollWidget = lazyLoad(() => import("./EmployeePayroll"), MyLoadingComponent);

const ProjectManagement = lazyLoad(() => import("./ProjectManagement"), MyLoadingComponent);

const ProjectTaskManagement = lazyLoad(() => import("./ProjectTaskManagement"), MyLoadingComponent);

const LatestPost = lazyLoad(() => import("./LatestPost"), MyLoadingComponent);

const ActivityBoard = lazyLoad(() => import("./ActivityBoard"), MyLoadingComponent);

const TrafficChannel = lazyLoad(() => import("./TrafficChannel"), MyLoadingComponent);

const ActiveUser = lazyLoad(() => import("./ActiveUser"), MyLoadingComponent);

const PersonalSchedule = lazyLoad(() => import("./PersonalSchedule"), MyLoadingComponent);

const Space = lazyLoad(() => import("./Space"), MyLoadingComponent);

const FollowersWidget = lazyLoad(() => import("./Followers"), MyLoadingComponent);

const BookingInfo = lazyLoad(() => import("./BookingInfo"), MyLoadingComponent);



const StockExchange = lazyLoad(() => import("./StockExchange"), MyLoadingComponent);

const TwitterFeeds = lazyLoad(() => import("./TwitterFeeds"), MyLoadingComponent);

const OurLocations = lazyLoad(() => import("./OurLocations"), MyLoadingComponent);

const BlogLayoutOne = lazyLoad(() => import("./BlogLayoutOne"), MyLoadingComponent);

const BlogLayoutTwo = lazyLoad(() => import("./BlogLayoutTwo"), MyLoadingComponent);

const BlogLayoutThree = lazyLoad(() => import("./BlogLayoutThree"), MyLoadingComponent);

const ShareFriends = lazyLoad(() => import("./ShareFriends"), MyLoadingComponent);

const PromoCoupons = lazyLoad(() => import("./PromoCoupons"), MyLoadingComponent);

const Rating = lazyLoad(() => import("./Rating"), MyLoadingComponent);

const VisitorAreaChartWidget = lazyLoad(() => import("./VisitorAreaChart"), MyLoadingComponent);

const SalesAreaChartWidget = lazyLoad(() => import("./SalesAreaChart"), MyLoadingComponent);

const OrdersAreaChartWidget = lazyLoad(() => import("./OrdersAreaChart"), MyLoadingComponent);

const OverallTrafficStatusWidget = lazyLoad(() => import("./OverallTrafficStatus"), MyLoadingComponent);

const TotalSalesWidget = lazyLoad(() => import("./TotalSales"), MyLoadingComponent);

const NetProfitWidget = lazyLoad(() => import("./NetProfit"), MyLoadingComponent);

const TaxStatsWidget = lazyLoad(() => import("./TaxStats"), MyLoadingComponent);

const ExpensesWidget = lazyLoad(() => import("./Expenses"), MyLoadingComponent);

const EmailStatisticsVersion2Widget = lazyLoad(() => import("./EmailStatisticsVersion2"), MyLoadingComponent);

const TotalEarnsChartWidget = lazyLoad(() => import("./TotalEarnsChart"), MyLoadingComponent);

const BandWidthAreaChartWidget = lazyLoad(() => import("./BandWidthAreaChart"), MyLoadingComponent);

const BandWidthUsageBarChartWidget = lazyLoad(() => import("./BandWidthUsageBarChart"), MyLoadingComponent);

const TotalEarnsWithAreaChartWidget = lazyLoad(() => import("./TotalEarnsWithAreaChart"), MyLoadingComponent);

const ProductStatsWidget = lazyLoad(() => import("./ProductStats"), MyLoadingComponent);

const EmailStaticsWidget = lazyLoad(() => import("./EmailStatics"), MyLoadingComponent);

const RevenueWidget = lazyLoad(() => import("./Revenue"), MyLoadingComponent);

const OnlineVisitorsWidget = lazyLoad(() => import("./OnlineVisitors"), MyLoadingComponent);

const TrafficSourcesWidget = lazyLoad(() => import("./TrafficSources"), MyLoadingComponent);

const BandwidthUsageWidget = lazyLoad(() => import("./BandwidthUsage"), MyLoadingComponent);

const SiteVisitorChartWidget = lazyLoad(() => import("./SiteVisitorsChart"), MyLoadingComponent);

const CommentsWidget = lazyLoad(() => import("./Comments"), MyLoadingComponent);

const TopSellingWidget = lazyLoad(() => import("./TopSelling"), MyLoadingComponent);

const RecentOrdersWidget = lazyLoad(() => import("./RecentOrders"), MyLoadingComponent);

const SocialCompaninesWidget = lazyLoad(() => import("./SocialCompanies"), MyLoadingComponent);

const Reminders = lazyLoad(() => import("./Reminders"), MyLoadingComponent);

const ContactRequestWidget = lazyLoad(() => import("./ContactRequest"), MyLoadingComponent);

const Notes = lazyLoad(() => import("./Notes"), MyLoadingComponent);

const WeatherWidget = lazyLoad(() => import("./Weather"), MyLoadingComponent);

const SocialFeedsWidget = lazyLoad(() => import("./SocialFeeds"), MyLoadingComponent);

const OrderStatusWidget = lazyLoad(() => import("./OrderStatus"), MyLoadingComponent);

const DiscoverPeoplesWidget = lazyLoad(() => import("./DiscoverPeoples"), MyLoadingComponent);

const ProductReportsWidget = lazyLoad(() => import("./ProductReports"), MyLoadingComponent);

const RecentActivity = lazyLoad(() => import("./RecentActivity"), MyLoadingComponent);

const ComposeEmailWidget = lazyLoad(() => import("./ComposeEmail"), MyLoadingComponent);

const CurrentTimeLocation = lazyLoad(() => import("./CurrentTimeLocation"), MyLoadingComponent);

const CurrentDateWidget = lazyLoad(() => import("./CurrentDate"), MyLoadingComponent);

const TodayOrdersStatsWidget = lazyLoad(() => import("./TodayOrdersStats"), MyLoadingComponent);

const ActivityWidget = lazyLoad(() => import("./Activity"), MyLoadingComponent);

const SessionSlider = lazyLoad(() => import("./SessionSlider"), MyLoadingComponent);

const AgencyWelcomeBlock = lazyLoad(() => import("./AgencyWelcomeBlock"), MyLoadingComponent);

const TrendingNews = lazyLoad(() => import("./TrendingNews"), MyLoadingComponent);

const TopHeadlines = lazyLoad(() => import("./TopHeadlines"), MyLoadingComponent);

const Visitors = lazyLoad(() => import("./Visitors"), MyLoadingComponent);

const Subscribers = lazyLoad(() => import("./Subscribers"), MyLoadingComponent);

const NewslaterCampaign = lazyLoad(() => import("./NewslaterCampaign"), MyLoadingComponent);

const TopAuthors = lazyLoad(() => import("./TopAuthors"), MyLoadingComponent);

const TopNews = lazyLoad(() => import("./TopNews"), MyLoadingComponent);

const TwitterFeedsV2 = lazyLoad(() => import("./TwitterFeedsV2"), MyLoadingComponent);

const ProjectStatusChart = lazyLoad(() => import("./ProjectStatusChart"), MyLoadingComponent);

const SalesDoughnutChart = lazyLoad(() => import("./SalesDoughnutChart"), MyLoadingComponent);

const LineChart = lazyLoad(() => import("./LineChart"), MyLoadingComponent);
const UpcomingEvents = lazyLoad(() => import("./UpcomingEvents"), MyLoadingComponent);

const OngoingProjects = lazyLoad(() => import("./OngoingProjects"), MyLoadingComponent);
const ProjectStatus = lazyLoad(() => import("./ProjectStatus"), MyLoadingComponent);
const NotificationV2 = lazyLoad(() => import("./NotificationV2"), MyLoadingComponent);

const LiveChatSupport = lazyLoad(() => import("./LiveChatSupport"), MyLoadingComponent);

const TransactionList = lazyLoad(() => import("./TransactionList"), MyLoadingComponent);

const ProjectStatsChart = lazyLoad(() => import("./ProjectStatsChart"), MyLoadingComponent);

const ProjectGallery = lazyLoad(() => import("./ProjectGallery"), MyLoadingComponent);

const Invoices = lazyLoad(() => import("./Invoices"), MyLoadingComponent);

const PaymentReport = lazyLoad(() => import("./PaymentReport"), MyLoadingComponent);

const TaxRates = lazyLoad(() => import("./TaxRates"), MyLoadingComponent);

const AddTickets = lazyLoad(() => import("./AddTickets"), MyLoadingComponent);

export {
   DailySales,
   ToDoListWidget,
   CampaignPerformance,
   SupportRequest,
   NewCustomersWidget,
   Notifications,
   UserProfile,
   QuoteOFTheDay,
   WeatherWidgetV2,
   NewEmailsWidget,
   EmployeePayrollWidget,
   ProjectManagement,
   ProjectTaskManagement,
   LatestPost,
   ActivityBoard,
   TrafficChannel,
   ActiveUser,
   PersonalSchedule,
   Space,
   FollowersWidget,
   BookingInfo,
   //NewOrderCountdown,
   StockExchange,
   TwitterFeeds,
   OurLocations,
   BlogLayoutOne,
   BlogLayoutTwo,
   BlogLayoutThree,
   ShareFriends,
   PromoCoupons,
   Rating,
   VisitorAreaChartWidget,
   SalesAreaChartWidget,
   OrdersAreaChartWidget,
   OverallTrafficStatusWidget,
   TotalSalesWidget,
   NetProfitWidget,
   TaxStatsWidget,
   ExpensesWidget,
   EmailStatisticsVersion2Widget,
   TotalEarnsChartWidget,
   BandWidthAreaChartWidget,
   BandWidthUsageBarChartWidget,
   TotalEarnsWithAreaChartWidget,
   ProductStatsWidget,
   EmailStaticsWidget,
   RevenueWidget,
   OnlineVisitorsWidget,
   TrafficSourcesWidget,
   BandwidthUsageWidget,
   SiteVisitorChartWidget,
   CommentsWidget,
   TopSellingWidget,
   RecentOrdersWidget,
   SocialCompaninesWidget,
   Reminders,
   ContactRequestWidget,
   Notes,
   WeatherWidget,
   SocialFeedsWidget,
   OrderStatusWidget,
   DiscoverPeoplesWidget,
   ProductReportsWidget,
   RecentActivity,
   ComposeEmailWidget,
   CurrentTimeLocation,
   CurrentDateWidget,
   TodayOrdersStatsWidget,
   ActivityWidget,
   SessionSlider,
   AgencyWelcomeBlock,
   TrendingNews,
   TopHeadlines,
   Visitors,
   Subscribers,
   NewslaterCampaign,
   TopAuthors,
   TopNews,
   TwitterFeedsV2,
   ProjectStatusChart,
   SalesDoughnutChart,
   LineChart,
   UpcomingEvents,
   OngoingProjects,
   ProjectStatus,
   NotificationV2,
   LiveChatSupport,
   TransactionList,
   ProjectStatsChart,
   ProjectGallery,
   Invoices,
   PaymentReport,
   TaxRates,
   AddTickets
}